import numeral from 'numeral';
import { isEmptyValue } from '../common';
import { commonValueFormat } from './dataFormatUtils';
import { FORMAT_RULE_MAP } from './contant';
import { numeralRegister } from './numeralRegister';
import { IFormatDataParams } from './_type';

// 直接执行numeralRegister，确保注册在dataFormat之前
numeralRegister();

/**
 * @description: 数据格式化
 * @param {IFormatDataParams} params 入参：value，formatRule，fillZero，emptyValue
 * @return {string}
 */
const dataFormat = (params: IFormatDataParams) => {
  const { value, formatRule, fillZero = true, emptyValue } = params || {};
  // 如果传入空字符串，则直接使用空字符串，如果不传，则用经分的默认'-'，所以可直接使用??
  const emptyStr = emptyValue ?? '-';
  if (isEmptyValue(value)) {
    return emptyStr;
  }
  try {
    const numValue = Number(value); // 将value转换为number类型
    // 如果不是数字，则直接返回，如：value 为'abc'
    if (isNaN(Number(numValue))) {
      return value;
    }
    // 如果是字符串，则使用快捷选项功能或者numeral兜底功能处理
    if (typeof formatRule === 'string') {
      return numeral(numValue).format(FORMAT_RULE_MAP?.[formatRule] || formatRule);
    } 
    // 不是字符串，则调用json格式化方法
    const { type, decimal } = formatRule || {
      type: 'int',
      decimal: 0
    };
    return commonValueFormat({value: numValue, type, decimal, fillZero, emptyValue: emptyStr});
  } catch (error) {
    // 兜底处理
    console.log('dataFormat error', error);
    return value;
  }
};

export default dataFormat;